import { Url } from '../../utils/codecUtils';
import { RelationType } from '../models/relations';
import { relationSchema } from '../models/relations.schema';
import { createRelationPayloadSchema } from './create.schema';

export type CreateRelationPayload = {
  type: RelationType;
  // Required for `custom` relations, must be omitted otherwise.
  name?: string;
  parent?: Url;
  annotations: Url[];
};

export const create = (payload: CreateRelationPayload) => {
  return {
    endpoint: '/relations',
    method: 'POST',
    payloadSchema: createRelationPayloadSchema,
    responseSchema: relationSchema,
    payload,
  } as const;
};
